/*eslint-disable*/export const messages=JSON.parse("{\"select.label.optional\":[\"(valfritt)\"]}");